/**
 * Fixed UI copy of „Moje objednávky“ (Figma 60323:19774, mobile 60459:90475) and „Detail
 * objednávky“ (60324:20208, mobile 60459:91415). Words that the core dictionary has letter for
 * letter (Všetky, Aktívne, Detail objednávky, Stav objednávky, Produkty, Medzisúčet, Doprava,
 * Platba, Kontaktné údaje, Doručenie, Fakturačná adresa, zadarmo, Prejsť do košíka, Skúsiť znova,
 * Zaplatiť objednávku) are read with `t()` in the components, the summary words come from the
 * checkout copy.
 */
export const ORDERS_COPY = {
  filters: {
    label: 'Filtrovať objednávky',
    delivered: 'Doručené',
    cancelled: 'Zrušené',
  },
  count: (label: string, count: number) => `${label} (${count})`,
  search: 'Číslo objednávky alebo produkt',
  found: (count: number) => `Nájdené objednávky: ${count}`,
  order: (identifier: string) => `Objednávka č. ${identifier}`,
  created: (date: string) => `Vytvorená ${date}`,
  createdAt: (date: string, time: string) => `Vytvorená ${date} o ${time}`,
  /** „Faktúra (PDF)“ – the label follows the name of the order's document. */
  document: (name: string) => `${name} (PDF)`,
  documentFallback: 'Faktúra',
  documentNumber: (name: string, number: string) => `${name} č. ${number}`,
  moreProducts: (count: number) => `+${count}`,
  moreProductsLabel: (count: number) => `a ďalšie produkty: ${count}`,
  reorder: 'Kúpiť znova',
  reorderFailed: 'Produkty z objednávky sa nepodarilo pridať do košíka.',
  reorderPartial: 'Niektoré produkty z objednávky sa nepodarilo pridať do košíka.',
  more: (count: number) => `Zobraziť staršie objednávky (${count})`,
  back: 'Späť na objednávky',
  help: {
    title: 'Máte problém s objednávkou?',
    text: 'Tovar môžete vrátiť do 14 dní od doručenia alebo ho reklamovať.',
    return: 'Vrátiť tovar',
    claim: 'Reklamovať',
  },
  empty: {
    title: 'Zatiaľ nemáte žiadne objednávky',
    text: 'Keď si u nás niečo objednáte, nájdete tu stav doručenia aj faktúry.',
    start: 'Začať nakupovať',
  },
  noResults: {
    title: 'Nenašli sme žiadnu objednávku',
    text: 'Skúste iné číslo objednávky alebo názov produktu.',
    reset: 'Zobraziť všetky objednávky',
  },
  loadFailed: 'Objednávky sa nepodarilo načítať.',
  detailFailed: 'Objednávku sa nepodarilo načítať.',
  notFound: {
    title: 'Objednávku sme nenašli',
    text: 'Vo vašom účte nie je objednávka s týmto číslom.',
  },
} as const;
